export enum ReportReceivedEnum {
  Daily = 1,
  Weekly = 2,
  Monthly = 3
}
